<script>
    import {tick} from 'svelte';
    import  Tabs from './Tabs.svelte';
    import  TabList from './TabList.svelte';
	import Lazy from './../../pages/Lazy.svelte'
    import Icon from '../../icons/Icon.svelte';
    import { itemClick } from '../../../../igen-shared-js/common';
    import { currentView } from '../../store';


    export let title
    export let back
    export let animateIt

    let activeTab = 0;
    let selectedTab =0; 
    let prevTab = 0;
    let active  = false;

    let classActive = ''
    let classBack = ''
    let classNext = 'slide-done-next'
    let classBefore= 'slide-done-before'
    
    //max 5 tabs
    const tabsItems = appMenu.slice(0,5)


    async function selectTab(id){
        selectedTab = id;
        if(id != activeTab){
            active = true;
            console.log('start' +id);
            if(id > activeTab){
                activeTab = id;
                classActive = 'slide';
                classBack = 'slide-back';
                //classDone = 'slide-done-next';

            }else{
                activeTab = id;
                classActive = 'slide-from-back';
                classBack = 'slide-left';
                //classDone = 'slide-done-next';
            }
            setTimeout(()=>{
                console.log('end');
                active= false;
                prevTab = id;
            },1000)
        }
    }

function setTabClass(id,selectedTab,prevTab){
    if(active){
        //move tabs
        console.log(id + ' '+ activeTab );
        if(selectedTab > prevTab)
        {
            if(selectedTab === id){
                return 'slide';
            }
            else if(prevTab === id){
                return 'slide-back';
            }else{
                return 'slide-done-next';
            }
            
        }else{

            if(selectedTab === id){
                return 'slide-left';
            }
            else if(prevTab === id){
                return 'slide-from-back';
            }else{
                return 'slide-done-before';
            }
        }
        
    }else{
        //not active state

        if(activeTab === id){
            return 'active-tab';
        }else{
            if(activeTab > id){
                return 'slide-done-before';
            }else{
                return 'slide-done-next';
            }
        }
        
        
    }
}

</script>

<Tabs>

    <slot></slot>
    
    <!-- {#each tabsItems as tab,index}
        <div class="tab-panel {setTabClass(index,selectedTab,prevTab)}" id="{index}">
            <Lazy  lid={index}  back={false} animateIt={false} />
        </div>
    {/each}  -->

    <TabList>
        {#each tabsItems as tab,index}
            <button on:click="{() => itemClick(tab) }" class="{index === $currentView ? 'selected':''}">
                <div class="icon tab-icon">
                    <Icon link={tab}/>
                </div>
                <div class="text">{tab.title}</div>
            </button>
        {/each}
    </TabList>
</Tabs>


<style>
	button {
		background: none;
		border: none;
		border-radius: 0; 
		margin: 0;
		color: rgba(255,255,255,.7);
        cursor: pointer;
        -webkit-tap-highlight-color: rgba(255,255,255,.1);
        width: 100%;
        display: flex;
        flex-direction: column;

        overflow: hidden;
        
	}
    
    button .icon{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height:40px;
        color:rgba(255,255,255,.7);
        fill: rgba(255,255,255,.7);
        margin: auto;
       
    }

    button .text{
        font-size: 0.9em;
        margin-bottom: 15px;
        width: 100%;
        text-align: center;

        
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: calc(100%);

    }

	.selected,.selected .icon {
        color: #fff;
        fill: #fff;
    }
    
    :global(.tab-panel){
        min-width: 100%;
        width: 100%;
        min-height:calc(100% - 75px);
		height: calc(100% - 75px);
        position: absolute;
        top:0;
    }

    :global(.tab-icon svg){
        margin: 0!important;
    }

    :global(.tab-icon .km-icon){
        font-size: 2em;
    }
    :global(.tab-icon .km-icon::after){
        margin-top: 0;
    }
</style>